
<template>
  <div class="atividades-rfilancamentos ml-4 mr-4">
    <b-form>
      <b-row>
        <!-- -->
        <b-col cols="3">
          <label for="select-empresa">Empresa</label>
          <multiselect
            id="selecao-empresa-sol"
            v-model="value_empresa"
            required
            :options="empresas"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            @close="loadFiliais()"
            :preserve-search="true"
            placeholder="Selecione a empresa"
            label="empresa"
            track-by="empresa"
            name="empresa"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} Empresa selecionada</span
              ></template
            >
          </multiselect>
        </b-col>

        <b-col cols="3">
          <label for="select-filial-lin">Filial</label>
          <multiselect
            id="selecao-filial-lin"
            v-model="value_filial"
            required
            :options="filiais"
            :multiple="true"
            :taggable="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Selecione a filial"
            label="filial"
            track-by="filial"
            name="filial"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} Filial selecionada</span
              ></template
            >
          </multiselect>
        </b-col>

        <b-col cols="2">
          <label for="select-situacao">Situação</label>
          <multiselect
            id="selecao-situcao-sol"
            v-model="value_situacao"
            required
            :options="statuss"
            :multiple="true"
            :taggable="true"
            @close="loadVeiculos()"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Selecione o status"
            label="status"
            track-by="status"
            name="status"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} Status selecionada</span
              ></template
            >
          </multiselect>
        </b-col>

        <LoadingModal v-if="isLoading" />

        <b-col cols="3">
          <label for="input-busca">Pesquisa no grid </label>
          <b-form-input
            id="buscamonitoramento"
            v-model="search"
            required="required"
            placeholder="prefixo / placa / chassi"
          ></b-form-input>
        </b-col>

        <b-col cols="1">
          <br />
          <b-button
            variant="warning"
            block
            class="mt-2 mr-2"
            v-b-modal.ModaleditarFuncionario
            >Novo</b-button
          >
        </b-col>
      </b-row>
    </b-form>

    <div class="d-flex justify-content-center mb-3">
      <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
    </div>
    <!--tbl de dados -->
    <b-table
      small
      hover
      striped
      sticky-header="762px"
      :items="itemsFiltered"
      :fields="fields"
    >
      <template slot="cell(actions)" slot-scope="data">
        <b-button
          @click="putFunc(data.item)"
          title="Editar veiculos"
          size="sm"
          variant="primary"
          class="mr-2 mt-2"
          v-b-modal.ModaleditarFuncionario
        >
          <i class="fa fa-pencil"></i>
        </b-button>
      </template>
    </b-table>
    <b-pagination
      size="xl"
      v-model="page"
      :total-rows="count"
      :per-page="limitcarro"
    ></b-pagination>

    <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
    <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
    <div>
      <b-modal
        id="ModaleditarFuncionario"
        cancel-title="Fechar"
        ok-title="Gravar"
        @ok="postveiculos()"
        @cancel="reset()"
        @close="reset()"
        hide-footer
        size="xl"
        title="Cadastro de veículos"
        no-close-on-esc
        no-close-on-backdrop
      >
        <!-- -->
        <div>
          <b-row>
            <b-col cols="7">
              <label for="input-filial">Empresa</label>
              <div>
                <b-form-select
                  id="fun-empresa"
                  v-model="veiculo.id_empresa"
                  required
                  :options="empresas"
                  class="mb-3"
                  text-field="empresa"
                  @change="loadFiliais()"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="5">
              <label for="input-filial">Filial</label>
              <div>
                <b-form-select
                  id="fun-filial"
                  v-model="veiculo.id_filial"
                  required
                  :options="filiais"
                  class="mb-3"
                  text-field="filial"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="3" class="mb-2 mt-6">
              <label for="input-registro">Prefixo</label>
              <b-form-input
                v-model="veiculo.prefixo"
                required
                placeholder="Nº do carro"
                v-b-tooltip.hover
                title="Digite o prefixo do veiculo"
              ></b-form-input>
            </b-col>

            <b-col cols="3" class="mb-2">
              <label for="input-live">Placa</label>
              <b-form-input
                v-model="veiculo.placa"
                placeholder="ND"
              ></b-form-input>
            </b-col>

            <b-col cols="3">
              <label for="input-admissao">Ano Fabricação</label>
              <b-form-datepicker
                id="datepicker-placeholder"
                v-model="veiculo.ano_fabricacao"
                required
                placeholder="Ano Fabricação"
                locale="pt-BR"
                date-format-options="DD/MM/YYYY"
              ></b-form-datepicker>
            </b-col>

            <b-col cols="3">
              <label for="input-admissao">Ano Modelo</label>
              <b-form-datepicker
                id="datepicker-placeholder"
                v-model="veiculo.ano_modelo"
                required
                placeholder="Ano Modelo"
                locale="pt-BR"
                date-format-options="DD/MM/YYYY"
              ></b-form-datepicker>
            </b-col>

            <b-col cols="4">
              <label for="input-chassifabricante">FABRICANTE</label>
              <div>
                <b-form-select
                  v-model="veiculo.chassifabricante_id"
                  required
                  :options="chassifabricantes"
                  class="mb-3"
                  text-field="fabricante"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="5">
              <label for="input-status">Modelo Chassi</label>
              <div>
                <b-form-select
                  v-model="veiculo.chassimodelo_id"
                  required
                  :options="chassimodelos"
                  class="mb-3"
                  text-field="modelo"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="3">
              <label for="input-status">Status</label>
              <div>
                <b-form-select
                  v-model="veiculo.id_status"
                  required
                  :options="statuss"
                  class="mb-3"
                  text-field="status"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="3">
              <label for="input-carroceriafabricantes"
                >FABRICANTE CARROCERIA</label
              >
              <div>
                <b-form-select
                  v-model="veiculo.carroceriafabricante_id"
                  required
                  :options="carroceriafabricantes"
                  class="mb-3"
                  text-field="fabricante"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="3">
              <label for="input-status">MODELO CARROCERIA</label>
              <div>
                <b-form-select
                  v-model="veiculo.carroceriamodelo_id"
                  required
                  :options="carroceriamodelos"
                  class="mb-3"
                  text-field="modelo"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="3">
              <label for="input-live">Nº CHASSI</label>
              <b-form-input
                id="tp_ts"
                v-model="veiculo.nrochassi"
                required
                placeholder=""
                v-b-tooltip.hover
                title="Digite o numero do chassi do veiculo"
              ></b-form-input>
            </b-col>

            <b-col cols="3">
              <label for="input-live">Nº RENAVAM</label>
              <b-form-input
                id="ts_tp"
                v-model="veiculo.renavam"
                required
                placeholder=""
                v-b-tooltip.hover
                title="Digite o renavam do veículo"
              ></b-form-input>
            </b-col>
          </b-row>

          <b-row class="mt-2 mb-2"> </b-row>

          <b-row class="mt-2">
            <b-col cols="3">
              <label for="input-frotatipos">TIPO DA FROTA</label>
              <div>
                <b-form-select
                  v-model="veiculo.tipofrota_id"
                  required
                  :options="frotatipos"
                  class="mb-3"
                  text-field="tipo"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="3">
              <label for="input-status">LOTE</label>
              <div>
                <b-form-select
                  v-model="veiculo.lote_id"
                  required
                  :options="lotes"
                  class="mb-3"
                  text-field="lote"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="3">
              <label for="input-live">DATA CADASTRO</label>
              <b-input-group-text>{{
                moment(veiculo.dt_cadastro)
                  .format("DD/MM/YYYY HH:mm")
                  .replace("Data inválida", "-")
              }}</b-input-group-text>
            </b-col>

            <b-col cols="3">
              <label for="input-live">DATA ALTERAÇÃO</label>
              <b-input-group-text>
                <template v-if="veiculo.dt_alteracao">
                  {{
                    moment(veiculo.dt_alteracao)
                      .format("DD/MM/YYYY HH:mm")
                      .replace("Data inválida", "-") +
                    (veiculo.re_alteracao
                      ? " - RE " + veiculo.re_alteracao
                      : "")
                  }}
                </template>
                <template v-else> dd/mm/yyyy </template>
              </b-input-group-text>
            </b-col>
          </b-row>

          <b-button class="mt-3" variant="success" block @click="postveiculos()"
            >Gravar</b-button
          >
        </div>
      </b-modal>
    </div>
    <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
  </div>
</template>


<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import Multiselect from "vue-multiselect";
import moment from "moment";
import { mapState } from "vuex";
import LoadingModal from "../utilitarios/LoadingModal";

export default {
  computed: {
    ...mapState(["user"]),

    itemsFiltered() {
      let valorefu = [];
      valorefu = this.veiculos.filter((item) => {
        const placa = item.placa || ""; // devido alguns valores retornarem null se faz necessario a substituição para não dar erro no filtro
        const cahssi = item.chassi || "";
        const prefixo = item.prefixo || "";
        return (
          placa.indexOf(this.search) > -1 ||
          cahssi.indexOf(this.search) > -1 ||
          prefixo.indexOf(this.search) > -1
        );
      });
      return valorefu;
    },
  },

  name: "FuncionarioCadastro",

  data: function () {
    return {
      veiculos: [],
      veiculo: {},

      chassifabricantes: [],
      chassimodelos: [],
      statuss: [],
      carroceriafabricantes: [],
      carroceriamodelos: [],
      frotatipos: [],
      lotes: [],

      value_situacao: [],
      value_empresa: [],
      value_filial: [],
      value_chassifabricante: [],
      value_chassimodelo: [],
      value_status: [],
      value_carroceriafabricante: [],
      value_carroceriamodelo: [],
      value_tipofrota: [],
      value_lote: [],

      mode: "save",
      carregando: false,
      atualizando: false,
      empresa: {},
      empresas: [], // [] lista
      filial: {},
      filiais: [], // [] lista
      funcionario: {},
      veiculos: [],
      funcoes: [],
      cnhs: [],
      page: 1,
      limitcarro: 0,
      count: 0,
      search: "",
      valor_empresa: "",
      selected: null,

      fields: [
        { key: "id_empresa", label: "Empresa", sortable: true },
        { key: "id_filial", label: "Filial", sortable: true },
        { key: "prefixo", label: "Carro", sortable: true },
        { key: "placa", label: "Placa", sortable: true },
        { key: "chassi", label: "Chassi", sortable: true },
        {
          key: "dt_cadastro",
          label: "Data cadastro",
          sortable: true,
          formatter: (value, key, veiculos) => {
            return moment(veiculos.dt_cadastro)
              .format("DD/MM/YYYY")
              .replace("Data inválida", "-");
          },
        },
        {
          key: "dt_alteracao",
          label: "Data alteração",
          sortable: true,
          formatter: (value, key, veiculos) => {
            return moment(veiculos.dt_alteracao)
              .format("DD/MM/YYYY - HH:mm")
              .replace("Data inválida", "-");
          },
        },
        /*
                { key: 'funcao', label: 'Função', sortable: true },                            
                { key: 'cpf', label: 'CPF', sortable: true },                
                { key: 'celular', label: 'Celular', sortable: true },                
                { key: 'situacao', label: ' Situação', sortable: true },                
                { key: 'versao_app', label: 'Versão', sortable: true },                
                    */
        { key: "actions", label: "Ações" },
      ],
    };
  },

  components: {
    Multiselect,
    LoadingModal,
  },

  methods: {
    handleOk(bvModalEvent) {
      // Prevent modal from closing
      bvModalEvent.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },

    loadEmpresa() {
      let params = {
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
      };

      const url = `${baseApiUrl}/ctr/empresa`;
      axios
        .get(url, { params })
        .then((res) => {
          this.empresas = res.data.map((emp) => {
            return {
              ...emp,
              value: emp.id_empresa,
              empresa: emp.nomeempresarial,
              id_filial_erp: emp.id_filial_erp,
            };
          });
        })
        .catch(showError);
    },

    loadFiliais() {
      let params = {
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
        id_empresa: `${this.user.id_empresa}`,
        id_grupo_empresa: `${this.user.id_empresa}`,
      };

      const url = `${baseApiUrl}/ctr/empresa/filial`;
      axios
        .get(url, { params })
        .then((res) => {
          this.filiais = res.data.map((fil) => {
            return { ...fil, value: fil.id_filial_erp, filial: fil.filial }; //// para pegar o valor tem que usar o ... atribuicao value
          });
        })
        .catch(showError);
    },

    loadVeiculos() {
      this.isLoading = true; // Ativa o indicador de carregamento

      // Prepara os parâmetros de consulta
      const params = {
        id_empresa: this.user.id_empresa,
        empresa_id: this.value_empresa.map((e) => e.id_empresa).join(","),
        id_filial: this.value_filial.map((f) => f.id_filial_erp).join(","),
        situacao_id: this.value_situacao.map((s) => s.id_situacao).join(","),
        page: this.page,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };

      const url = `${baseApiUrl}/frota/listagemveiculos`;

      // Faz a requisição GET com parâmetros de consulta
      axios
        .get(url, { params })
        .then((res) => {
          this.veiculos = res.data.data;
          this.isLoading = false; // Desativa o indicador de carregamento
          this.count = res.data.count;
          this.limitcarro = res.data.limitcarro;
        })
        .catch((err) => {
          this.isLoading = false; // Em caso de erro, desativa o indicador
          console.error(err);
        });
    },

    loadFabricanteChassi() {
      let params = {
        id_empresa: `${this.user.id_empresa}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };
      const url = `${baseApiUrl}/frota/chassifabricante`;
      axios
        .get(url, { params })
        .then((res) => {
          this.chassifabricantes = res.data.map((gru) => {
            return { ...gru, value: gru.id, fabricante: gru.fabricante };
          });
        })
        .catch(showError);
    },

    loadModeloChassi() {
      let params = {
        empresa_id: this.user.id_empresa
          ? `${this.user.id_empresa}`
          : `${this.value_empresa.map((e) => e.id_empresa)}`,
        origem: "web",
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };
      const url = `${baseApiUrl}/frota/chassimodelo`;
      axios
        .get(url, { params })
        .then((res) => {
          this.chassimodelos = res.data.map((gru) => {
            return { ...gru, value: gru.id, modelo: gru.modelo };
          });
        })
        .catch(showError);
    },

    loadveiculoStatus() {
      let params = {
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };
      const url = `${baseApiUrl}/frota/veiculostatus`;
      axios
        .get(url, { params })
        .then((res) => {
          this.statuss = res.data.map((gru) => {
            return { ...gru, value: gru.id, status: gru.status };
          });
        })
        .catch(showError);
    },

    loadCarroceriaFabricante() {
      let params = {
        id_empresa: `${this.user.id_empresa}`,
        empresa_id: `${this.value_empresa.map((e) => e.id_empresa)}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };
      const url = `${baseApiUrl}/frota/carroceriafabricante`;
      axios
        .get(url, { params })
        .then((res) => {
          this.carroceriafabricantes = res.data.map((gru) => {
            return { ...gru, value: gru.id, fabricante: gru.fabricante };
          });
        })
        .catch(showError);
    },

    loadCarroceriaModelo() {
      let params = {
        id_empresa: `${this.user.id_empresa}`,
        empresa_id: `${this.value_empresa.map((e) => e.id_empresa)}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };
      const url = `${baseApiUrl}/frota/carroceriamodelo`;
      axios
        .get(url, { params })
        .then((res) => {
          this.carroceriamodelos = res.data.map((gru) => {
            return { ...gru, value: gru.id, modelo: gru.modelo };
          });
        })
        .catch(showError);
    },

    loadTipoFrota() {
      let params = {
        id_empresa: `${this.user.id_empresa}`,
        empresa_id: `${this.value_empresa.map((e) => e.id_empresa)}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };
      const url = `${baseApiUrl}/frota/tipofrota`;
      axios
        .get(url, { params })
        .then((res) => {
          this.frotatipos = res.data.map((gru) => {
            return { ...gru, value: gru.id, tipo: gru.tipo };
          });
        })
        .catch(showError);
    },

    loadLote() {
      let params = {
        id_empresa: `${this.user.id_empresa}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };
      const url = `${baseApiUrl}/planejamento/escala/lote`;
      axios
        .get(url, { params })
        .then((res) => {
          this.lotes = res.data.map((gru) => {
            return { ...gru, value: gru.id_lote, lote: gru.lote };
          });
        })
        .catch(showError);
    },

    putFunc(veiculo) {
      this.veiculo = { ...veiculo };
    },

    postveiculos() {
      let corpo = {
        id_veiculo: `${this.veiculo.id_veiculo}`,
        id_grupo: `${this.user.id_grupo_empresa}`,
        id_empresa_erp: `${this.veiculo.id_empresa}`,
        id_garagem: `${this.veiculo.id_filial}`, // pegar o valor da filial
        id_erp: `${this.veiculo.id_erp}`, // ERP terceiro deverá passar
        prefixo: `${this.veiculo.prefixo}`,
        placa: `${this.veiculo.placa}`,
        ano_fabricacao: `${this.veiculo.ano_fabricacao}`,
        ano_modelo: `${this.veiculo.ano_modelo}`,
        media_consumo: `${this.veiculo.media_consumo}`,
        id_status: `${this.veiculo.id_status}`,
        //"id_destinacao": `${this.veiculo.id_destinacao}`,  substituido por tipofrota_id
        //"chassi": `${this.veiculo.cpf}`,
        //"dt_alteracao": this.veiculo.dt_alteracao ?  `${this.veiculo.dt_alteracao}`: null,
        //"id_funcionario_alteracao": `${this.veiculo.id_funcionario_alteracao}`,
        //"dt_cadastro": this.veiculo.dt_cadastro ?  `${this.veiculo.dt_cadastro}` : null,
        id_funcionario: `${this.user.id_funcionario}`,
        //"lote": `${this.veiculo.dt_demissao}`,
        //"id_modelo_chassi": `${this.veiculo.id_modelo_chassi}`,
        foto: `${this.veiculo.foto}`,
        //"modelo": `${this.veiculo.dt_cnh_validade}`,
        id_empresa: `${this.user.id_empresa}`, //empresa
        renavam: `${this.veiculo.renavam}`,
        nrochassi: `${this.veiculo.nrochassi}`,
        chassifabricante_id: `${this.veiculo.chassifabricante_id}`,
        chassimodelo_id: `${this.veiculo.chassimodelo_id}`,
        carroceriafabricante_id: `${this.veiculo.carroceriafabricante_id}`,
        carroceriamodelo_id: `${this.veiculo.carroceriamodelo_id}`,
        tipofrota_id: `${this.veiculo.tipofrota_id}`,
        lote_id: `${this.veiculo.lote_id}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };
      const url = `${baseApiUrl}/frota/cadfrota`;
      axios
        .post(url, corpo)
        .then(() => {
          this.$toasted.global.defaultSuccess(), this.reset(); //limpar os objetos valores
        })
        .catch(showError);
    },

    reset() {
      this.veiculo = {};
      this.loadVeiculos();
    },
  },

  watch: {
    page() {
      this.loadVeiculos();
    },
  },

  mounted() {
    this.loadEmpresa();
    this.loadFiliais();
    this.loadVeiculos();
    this.loadFabricanteChassi();
    this.loadModeloChassi();
    this.loadveiculoStatus();
    this.loadCarroceriaFabricante();
    this.loadCarroceriaModelo();
    this.loadTipoFrota();
    this.loadLote();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
#selecaostatusx {
  font-size: 0.7em;
}
</style>
